export const routeData = {
  dashboard: "dashboard",
  funds: "funds",
  fundsPortfolio: "funds-portfolio",
  stocks: "stocks",
  balanceSheet: "balance-sheet",
  financeInfor: "finance-infor",
  financeCategory: "finance-category",
};
